import { RESERVATION } from "../../utils/constants";
import { get, post, put } from "../../utils/axios-config";
import { ReservationType } from "../../types/Library";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";

export const createReservation = async (data: ReservationType) => await post(RESERVATION, data);

export const updateReservation = async (data: ReservationType) => await put(RESERVATION, data);

export const getReservations = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || "1",
        PageSize: data?.PageSize?.toString() || "100",
        ...(data?.IdBook ? { IdBook: data.IdBook  } : {}),
        ...(data?.IdUser ? { IdUser: data.IdUser  } : {}),
    });
    const url = `${RESERVATION}?${queryParams.toString()}`;
    return await get<PagedResultsType<ReservationType>>(url);
};
